export const skippedTabs = ["_key", "status", "_reports"];

export function setNestedProperty(object, property, value) {
	if (object && typeof object == "object")
		if (typeof property === "string" && property !== "") {
			var split = property.split(".");
			return split.reduce(function (obj, prop, idx) {
				if (!obj[prop]) {
					// if next prop is Number, create Array instead of Object (FE: telephoneNumbers.0.number)
					if (split.length > idx + 1 && !isNaN(split[idx + 1])) {
						obj[prop] = [];
					} else {
						obj[prop] = {};
					}
				}

				if (split.length == (idx + 1)) {
					obj[prop] = value;
				}

				return obj[prop];
			}, object);
		} else if (typeof property === "number") {
			object[property] = value;
			return object[property];
		}

	return object;
}

export function getNestedProperty(object, property) {
	if (object && typeof object == "object")
		if (typeof property == "string" && property !== "") {
			var split = property.split(".");
			return split.reduce(function (obj, prop) {
				return obj && obj[prop];
			}, object);
		} else if (typeof property == "number") {
			return object[property];
		}

	return object;
}

export function groupBy(list, keyGetter) {
	const map = new Map();
	list.forEach((item) => {
		const key = keyGetter(item);
		const collection = map.get(key);
		if (!collection) {
			map.set(key, [item]);
		} else {
			collection.push(item);
		}
	});
	return map;
}

export function computeParts(schema) {
	const props = [];

	if (!schema) return;

	const processProp = (prop, name) => {
		if (prop == undefined) return;

		prop.name = name;
		prop.req = (schema.required != undefined && schema.required.indexOf(name) > -1);
        
		props.push(prop);
	};

	if (schema.order && schema.order.length > 0) {
		for (const o of schema.order) {
			const prop = schema.properties[o];
			processProp(prop, o);
		}
	} else {
		for (const p in schema.properties) {
			const prop = schema.properties[p];
			processProp(prop, p);
		}
	}

	return props;
}

export function updateSw(newLud) {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.ready.then(swr => {
			//if (confirm("We have new verstion of the app. Do you want to update now?")) {
			caches.keys().then((keys) => {
				const cacheName = keys.find(k => k.startsWith("sw-precache-v3-sw-precache"));
				if (cacheName) {
					caches.delete(cacheName).then(() => {
						localStorage.lud = newLud;
						swr.unregister();
						location.reload();
					});
				} else {
					localStorage.lud = newLud;
				}
			});
			//}
		});
	}
}

export function createOverlay(addToDocument = true){
	let overlay = document.createElement("div");
	overlay.style.cssText = `
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		z-index: 9999;
		display: flex;
		justify-content: center;
		background-color: #4e4e58b8;
	`;
	if (addToDocument) {
		document.body.appendChild(overlay);	
	}
	return overlay;
}